<p-dialog
    [(visible)]="visible"
    [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
    [style]="{ width: '50rem' }"
    [modal]="true"
    class="p-fluid"
    [resizable]="false"
    [draggable]="false"
    (onHide)="fechar()"
>
    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2 w-full">
            <i class="pi pi-user text-700"></i>
            <span class="text-xl font-semibold text-900">
                {{ profissional?.nomeProfissional }}
            </span>
            <span class="text-lg text-900">
                - {{dataSelecionada | date:'dd/MM/yyyy'}}
            </span>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <p-table
            #dt1
            [value]="agendamentos"
            dataKey="id"
            [lazy]="true"
            [paginator]="true"
            [rows]="5"
            [totalRecords]="totalRegistros"
            (onLazyLoad)="onLazyLoad($event)"
            [loading]="loading"
            sortMode="single"
            [rowHover]="true"
            [showCurrentPageReport]="true"
            responsiveLayout="scroll"
            styleClass=" p-datatable-sm"
            currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros"
        >
            <ng-template pTemplate="caption">
                <div class="flex justify-content-start">
                    <p-dropdown
                        [options]="listaStatus"
                        [(ngModel)]="statusSelecionado"
                        (ngModelChange)="filtrar()"
                    ></p-dropdown>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th>Cliente</th>
                    <th>Status</th>
                    <th>Data</th>
                    <th>Início</th>
                    <th>Fim</th>
                    <th>Ações</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td>
                        {{ item.nomeCliente }}
                    </td>
                    <td class="text-left">
                        <span class="status-badge-agenda"
                        [ngStyle]="item.status | agendaStatusStyle">
                            {{ item.status }}
                        </span>
                    </td>
                    <td>
                        {{ item.dataAgendamento | date : "dd/MM/yyyy" }}
                    </td>
                    <td>
                        {{ item.horaInicio }}
                    </td>
                    <td>
                        {{ item.horaFim }}
                    </td>
                    <td>
                        <button
                            pButton
                            pRipple
                            pTooltip="Detalhar"
                            icon="pi pi-eye"
                            class="p-button-info"
                            (click)="abrirDetalhe(item.id)"
                        ></button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="7">Nenhum registro encontrado.</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="loadingbody">
                <tr>
                    <td colspan="7">Carregando grupos. Por favor aguarde.</td>
                </tr>
            </ng-template>
        </p-table>
    </ng-template>

    <ng-template pTemplate="footer"></ng-template>
</p-dialog>
